import { Col } from '@repo/ui/components'
import type { WalletProjectPropertyCardsProps } from './wallet.types'
import { Fragment } from 'react'
import { WalletProjectPropertyCardItem } from './wallet-project-property.card-item'
import { WalletProjectsEmptyState } from './wallet-projects.empty-state'
import { UserProject } from '@repo/services'

export const WalletProjectPropertyCards = ({
  projects,
  userProjects,
  isLoading,
}: WalletProjectPropertyCardsProps) => {
  const userPropertyProjects = userProjects.filter((userProject) =>
    projects.find(
      (project) =>
        project.token === userProject.currency && project.kind === 'property',
    ),
  )
  return (
    <Col className=''>
      {userProjects.map((userProject) => (
        <Fragment key={userProject.currency}>
          <WalletProjectPropertyCardItem
            project={
              projects.find(
                (project) =>
                  project.token === userProject.currency &&
                  project.kind === 'property',
              ) as UserProject
            }
            userProject={userProject}
          />
        </Fragment>
      ))}
      {}
      {userPropertyProjects.length === 0 && !isLoading && (
        <WalletProjectsEmptyState isLoading={isLoading} />
      )}
    </Col>
  )
}
